<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->
<nav class="navbar shadow navbar-expand-md navbar-light bg-white">
  <div class="container-fluid align-items-center">
    <!-- Logo on the left -->

    <div class="col-4">
      <a routerLink="/Home">
        <img src="/assets/logo.png" class="logo" alt="Logo" />
      </a>
    </div>
    <div class="col-8 menu">
      <ul>
        <li routerLink="/search" >
          <img src="/assets/Search_Icons_UIA.png">
        </li>
        <li (click)='toggleLanguage()' >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="#3eafe0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 0 20a15.3 15.3 0 0 1 0-20"></path>
          </svg>
        </li>
      </ul>
    </div>
  </div>
</nav>